module.exports = __webpack_public_path__ + "img/google.51d18a44.svg";